module.exports = __webpack_public_path__ + "img/building95-5.65ff17bf.jpg";